import React, { Children, forwardRef } from 'react';
import '../../App.css';

const Input = ({name, type, placeholder, style, ...rest}) => {    
    return (
        <input className='form-control shadow-none custom-input' type={type} placeholder={placeholder} name={name} id={name} style={style} {...rest}></input>
    );
}

const InputSearch = forwardRef(({iconRight, iconLeft, name, type, placeholder, style, ...rest}, ref) => {    
    return (
        <div className="input-group custom-search-input">
            <span className="input-group-text">
                <i className={iconLeft}></i>
            </span>
            <input type={type} className='form-control shadow-none' placeholder={placeholder} id={name} name={name} style={{ height: "40px", ...style }} ref={ref} {...rest}></input>
            <span className="input-group-text">
                {iconRight == 'loading' ? (
                        <div className="spinner-border spinner-border-sm" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    ) : (
                        <i className={iconRight}></i>
                    )
                }
            </span>
        </div>
    );
});

const TextArea = ({ placeholder, name, style, ...rest}) => {
    return (
        <textarea className='form-control shadow-none custom-textarea' placeholder={placeholder} name={name} id={name} style={style} {...rest}></textarea>
    );
}

const TextAreaLabel = ({ id, name, label, placeholder, rows }) => {
    return (
        <div className="mb-3">
            <label htmlFor={id} className="form-label">{label}</label>
            <textarea className="form-control shadow-none" id={id} name={name} placeholder={placeholder} rows={rows}></textarea>
        </div>
    )
}

const Radio = ({ id, name, label, value, ...rest }) => {
    return (
        <div className="form-check">
            <input className="form-check-input" type="radio" name={name} id={id} value={value} {...rest} />
            <label className="form-check-label" htmlFor={id}>
              {label}
            </label>
        </div>
    )
}

/**
 * Adding option elements to select element
 * 
 * @param {items} array - Array of objects - [ {value: '', label: ''} ]
 */
const Select = ({ id, label, name, items = [], style }) => {
    return (
        <div>
            {label && <label htmlFor={id}>{label}</label>}
            <select className="form-select shadow-none" id={id} name={name} style={style}>
                {items.map((item, index) => (
                    <option key={index} value={item.value}>{item.label}</option>
                ))}
            </select>
        </div>
    );
};

/**
 * Adding option elements to select element
 * 
 * @param {items} array - Array of objects - [ {value: '', label: ''} ]
 */
const SelectRow = ({ id, label, name, items = [] }) => {
    return (
        <div className="row my-3">
            <div className="col-4">
                {label && <label htmlFor={id}>{label}</label>}  
            </div>
            <div className="col-8">
                <select className="form-select shadow-none" id={id} name={name}>
                    {items.map((item, index) => (
                        <option key={index} value={item.model}>{item.model}</option>
                    ))}
                </select>
            </div>
        </div>
    )
}

const CheckBox = ({ id, value, label }) => {
    return (
        <div className="form-check">
            <input className="form-check-input" type="checkbox" value={value} id={id} />
            <label className="form-check-label" for={id}>
              {label}
            </label>
        </div>
    )
}

export {Input, InputSearch, TextArea, Radio, Select, SelectRow};